const collections = [
    {
      img: "/image/collection/img-1.jpg",
      count: 1,
      check : 'fa fa-check',
      title: "NFT Funny cart",
      content: "7,080.95 ETH",
      category : 'a',
    },
    {
      img: "/image/collection/img-2.jpg",
      content: "5340.95 ETH",
      check : 'fa fa-check',
      title: "Cryptopank",
      count: 2,
      category : 'b',
    },
    {
      img: "/image/collection/img-3.jpg",
      content: "5340.95 ETH",
      title: "Price App Planet",
      count: 3,
      category : 'b',
    },
    {
      img: "/image/collection/img-4.jpg",
      content: "5340.95 ETH",
      check : 'fa fa-check',
      title: "Hey Marmeshak",
      count: 4,
      category : 'b',
    },
    {
      img: "/image/collection/img5.jpg",
      content: "5340.95 ETH",
      title: "Bored Bunny",
      count: 5,
      category : 'b',
    },
    {
      img: "/image/collection/img-6.jpg",
      content: "5340.95 ETH",
      title: "Wow Frens",
      count: 6,
      category : 'b',
    },
    {
      img: "/image/collection/img-7.jpg",
      content: "5340.95 ETH",
      title: "Origin Moresh",
      count: 7,
      category : 'b',
    },
    {
      img: "/image/collection/img-8.jpg",
      content: "5340.95 ETH",
      check : 'fa fa-check',
      title: "Sperdo",
      count: 8,
      category : 'a',

    },
    {
      img: "/image/collection/img-9.jpg",
      content: "5340.95 ETH",
      check : 'fa fa-check',
      title: "Nft Star",
      count: 9,
      category : 'a',

    },
    {
      img: "/image/collection/img-10.jpg",
      content: "5340.95 ETH",
      title: "Asumitsu",
      count: 10,
      category : 'a',

    },
    {
      img: "/image/collection/img-11.jpg",
      content: "5340.95 ETH",
      count: 11,
      category : 'a',

    },
    {
      img: "/image/collection/img-12.jpg",
      content: "5340.95 ETH",
      check : 'fa fa-check',
      title: "Lazy Panda",
      count: 12,
    },
    {
      img: "/image/collection/img-13.jpg",
      content: "5340.95 ETH",
      title: "Archorizons",
      count: 13,
    },
    {
      img: "/image/collection/img-14.jpg",
      content: "5340.95 ETH",
      title: "Sussygirl",
      count: 14,
    },
    {
      img: "/image/collection/img-15.jpg",
      content: "5340.95 ETH",
      check : 'fa fa-check',
      title: "Smilebin",
      count: 15,
    },
    {
      img: "/image/collection/img-16.jpg",
      content: "5340.95 ETH",
      check : 'fa fa-check',
      title: "Panki smoke",
      count: 16,
    },
  ];


  export default collections;